
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import { compareDesc } from 'date-fns';
import { Message } from '@/model/message';

export default Vue.extend({
  name: 'VisionMarche',
  props: {
    maxHeight: {
      type: Number,
      default: null
    },
    idArticle: {
      type: Number,
      required: false
    }
  },
  data: () => ({
    messageOverflow: false,
    dernierMessage: null as string
  }),
  computed: {
    ...mapGetters({ messages: 'visionMarcheArticleEngrais/liste' })
  },
  created () {
    this.loadListe().then(() => {
      if (this.isOverflown(this.$refs.message as Element)) {
        this.messageOverflow = true;
      }
    });
  },
  methods: {
    ...mapActions({
      loadListe: 'visionMarcheArticleEngrais/loadListe'
    }),
    isOverflown (element:Element):boolean {
      if (!element) {
        return false;
      }
      return element.scrollHeight > element.clientHeight;// || element.scrollWidth > element.clientWidth;
    },
    open () {
      this.$dialog.confirm({
        icon: 'mdi-help-circle-outline',
        // title: this.title,
        text: this.visionPubliee(this.idArticle),
        width: 900,
        actions: {
          false: {
            text: 'Fermer',
            flat: false,
            outlined: true,
            color: 'grey'
          }
        }
      });
    },
    visionPubliee (idArticle:number):string {
      const vision = this.messages
        .slice()
        .filter((a:Message) => a.targetId && a.targetId === idArticle)
        .filter((a:Message) => a.dateFin == null || a.dateFin === undefined)
        .sort((a:Message, b:Message) => compareDesc(a.datePublication, b.datePublication))[0];

      return vision !== undefined ? vision.texte : '';
    }
  }
});
